class Configuration {
  IS_ORGANIZATION_API_ENABLED: boolean
  IS_USER_API_ENABLED: boolean
  IS_CONTRACTS_API_ENABLED: boolean
  IS_PRODUCTS_API_ENABLED: boolean
  MY_PERMISSIONS_VISIBLE: boolean
  IS_BUILD_NODE_ID_LABEL_ENABLED: boolean

  constructor() {
    this.IS_ORGANIZATION_API_ENABLED = this.assertNotEmpty("IS_ORGANIZATION_API_ENABLED") === "true"
    this.IS_USER_API_ENABLED = this.assertNotEmpty("IS_USER_API_ENABLED") === "true"
    this.IS_CONTRACTS_API_ENABLED = this.assertNotEmpty("IS_CONTRACTS_API_ENABLED") === "true"
    this.MY_PERMISSIONS_VISIBLE = this.assertNotEmpty("MY_PERMISSIONS_VISIBLE") === "true"
    this.IS_PRODUCTS_API_ENABLED = this.assertNotEmpty("IS_PRODUCTS_API_ENABLED") === "true"
    this.IS_BUILD_NODE_ID_LABEL_ENABLED =
      this.assertNotEmpty("IS_BUILD_NODE_ID_LABEL_ENABLED") === "true"
  }

  private assertNotEmpty(name: string = ""): string {
    const value: string | undefined = (
      import.meta.env as unknown as Record<string, string | undefined>
    )[`VITE_${name}`]

    if (!value) {
      throw new Error(`Configuration: ${name} is empty`)
    }

    return value
  }
}

const configuration = new Configuration()

export default configuration
